import { render, staticRenderFns } from "./AscMxRecConfirmSubmitDialog.vue?vue&type=template&id=f5cbcc72&"
import script from "./AscMxRecConfirmSubmitDialog.vue?vue&type=script&lang=js&"
export * from "./AscMxRecConfirmSubmitDialog.vue?vue&type=script&lang=js&"
import style0 from "./AscMxRecConfirmSubmitDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports